import React from "react";
import { Row, Col, Typography, Space, Button, Modal } from "antd";
import Styles from "./RemoveWheelchairPopup.module.scss";
import { IServiceUserInfo } from "../../../../types/ServiceUserInfo";

type Props = {
    isRemoveWheelchair: boolean;
    handleCancelWheelchairModal: () => void;
    handleContinueWheelchairModal: () => void;
    serviceUserData: IServiceUserInfo;
};

const RemoveWheelchairPopup: React.FC<Props> = ({
    isRemoveWheelchair,
    handleCancelWheelchairModal,
    handleContinueWheelchairModal,
    serviceUserData,
}) => {
    return (
        <Modal
            onOk={handleCancelWheelchairModal}
            onCancel={handleCancelWheelchairModal}
            visible={isRemoveWheelchair}
            okButtonProps={{ hidden: true }}
            cancelButtonProps={{ hidden: true }}
            centered={true}
            footer={
                <Row className={Styles.modalContainer}>
                    <Col span={24}>
                        <Row justify="center">
                            <Typography.Text className={Styles.modalHeader}>
                                Remove Wheelchair
                            </Typography.Text>
                        </Row>
                        <Row justify="center" className={Styles.wheelChairSection}>
                            <Col>
                                <p className={Styles.modalBodyText}>
                                    Are you sure that {serviceUserData && serviceUserData.firstName} doesn’t need to travel with a wheelchair?
                                </p>
                            </Col>
                        </Row>
                        <Row justify="center" className={Styles.wheelChairSection}>
                            <Col>
                                <p className={Styles.modalBodyText}>
                                    <b>Note:</b> If you move forward, we’ll also remove the
                                    wheelchair from {serviceUserData && serviceUserData.firstName}'s profile.
                                </p>
                            </Col>
                        </Row>
                        <Row justify="center" className={Styles.wheelChairSection}>
                            <Col className={Styles.modalBtn}>
                                <Space>
                                    <Button
                                        className={Styles.buttonTheme}
                                        onClick={handleCancelWheelchairModal}
                                    >
                                        Cancel
                                    </Button>

                                    <Button
                                        className={Styles.buttonThemeBlue}
                                        onClick={handleContinueWheelchairModal}
                                    >
                                        Confirm
                                    </Button>
                                </Space>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            }
        />
    )
};

export default RemoveWheelchairPopup;
